import React from "react";
import "./Column.scss";
/**
 * Flex layout in column order.
 *
 * Note that this spaces children with 5px.
 */
const Column = ({ className, align = "center", children }) => (React.createElement("div", { className: `aui-column align-${align} ${className !== null && className !== void 0 ? className : ""}` }, children));
export default Column;
